// extracted by mini-css-extract-plugin
export default {"horizontalLine":"HorizontalLine_horizontalLine__y5jus"};